import { Alert as MaterialAlert } from '@mui/material'

const Alert = MaterialAlert

export { Alert }
